module.exports = __webpack_public_path__ + "img/symbol_4.196ca03d.png";